var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInferenceExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4257_47131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 13.4803C12.5391 14.5853 11.4191 15.4803 10.0391 15.4803C8.65906 15.4803 7.53906 14.5853 7.53906 13.4803C7.53906 12.3753 8.65906 11.4803 10.0391 11.4803C11.4191 11.4803 12.5391 12.3753 12.5391 13.4803Z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5391 3.48032V13.4803H11.5391V3.48032H12.5391Z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5391 3.30032C11.5392 3.06923 11.6194 2.84532 11.7659 2.66666C11.9125 2.488 12.1165 2.36562 12.3431 2.32032L15.3431 1.72032C15.4881 1.69134 15.6377 1.69488 15.7812 1.73069C15.9247 1.7665 16.0585 1.8337 16.1729 1.92743C16.2873 2.02117 16.3794 2.1391 16.4428 2.27275C16.5061 2.4064 16.539 2.55243 16.5391 2.70032V4.48032L11.5391 5.48032V3.30032Z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.539062 11.9803C0.539062 11.8477 0.591741 11.7205 0.685509 11.6268C0.779277 11.533 0.906454 11.4803 1.03906 11.4803H4.53906C4.67167 11.4803 4.79885 11.533 4.89262 11.6268C4.98638 11.7205 5.03906 11.8477 5.03906 11.9803C5.03906 12.1129 4.98638 12.2401 4.89262 12.3339C4.79885 12.4276 4.67167 12.4803 4.53906 12.4803H1.03906C0.906454 12.4803 0.779277 12.4276 0.685509 12.3339C0.591741 12.2401 0.539063 12.1129 0.539062 11.9803ZM0.539062 7.98032C0.539062 7.84772 0.591741 7.72054 0.685509 7.62677C0.779277 7.533 0.906454 7.48032 1.03906 7.48032H8.53906C8.67167 7.48032 8.79885 7.533 8.89262 7.62677C8.98638 7.72054 9.03906 7.84772 9.03906 7.98032C9.03906 8.11293 8.98638 8.24011 8.89262 8.33388C8.79885 8.42765 8.67167 8.48032 8.53906 8.48032H1.03906C0.906454 8.48032 0.779277 8.42765 0.685509 8.33388C0.591741 8.24011 0.539063 8.11293 0.539062 7.98032ZM0.539062 3.98032C0.539062 3.84772 0.591741 3.72054 0.685509 3.62677C0.779277 3.533 0.906454 3.48032 1.03906 3.48032H8.53906C8.67167 3.48032 8.79885 3.533 8.89262 3.62677C8.98638 3.72054 9.03906 3.84772 9.03906 3.98032C9.03906 4.11293 8.98638 4.24011 8.89262 4.33388C8.79885 4.42765 8.67167 4.48032 8.53906 4.48032H1.03906C0.906454 4.48032 0.779277 4.42765 0.685509 4.33388C0.591741 4.24011 0.539063 4.11293 0.539062 3.98032Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4257_47131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.539062 0.480347)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInferenceExplorer);
export default __webpack_public_path__ + "static/media/inference-explorer.5edba6a4521e56893deb3a9628bea8c2.svg";
export { ForwardRef as ReactComponent };